import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlDisabledDirective } from './control-disabled.directive';

@NgModule({
  declarations: [ControlDisabledDirective],
  imports: [CommonModule],
  exports: [ControlDisabledDirective],
})
export class ControlDisabledDirectiveModule {}
